import { render, staticRenderFns } from "./ImportProcessFromMermaidGraph.vue?vue&type=template&id=572d69ac&scoped=true&"
import script from "./ImportProcessFromMermaidGraph.vue?vue&type=script&lang=js&"
export * from "./ImportProcessFromMermaidGraph.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572d69ac",
  null
  
)

export default component.exports